<div class="w-full py-3 px-4">
    <!-- create user Title Section -->
    <div class="sm:flex items-center justify-between mb-4">
        <div class="flex items-center justify-start gap-1 lg:gap-2 mb-3 lg:mb-0">
            <!-- Back Button SVG (clickable) -->
            <svg class="size-6 cursor-pointer" [routerLink]="['/home']" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">

                <mask id="mask0_848_1764" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24"
                    height="24">
                    <rect width="24" height="24" fill="#C19725" />
                </mask>
                <g mask="url(#mask0_848_1764)">
                    <path d="M16 22L6 12L16 2L17.775 3.775L9.55 12L17.775 20.225L16 22Z" fill="#C19725" />
                </g>
            </svg>
            <img class="size-6 sm:size-8 lg:size-10" src="/assets/images/raw-metal/raw-metal.png" alt="Raw Metal">
            <span class="font-semibold text-sm sm:text-base lg:text-xl text-444">Raw Metal Entry</span>
        </div>

        <div
            class="overflow-x-auto overflow-y-hidden whitespace-nowrap scrollbar-hide md:overflow-x-hidden order-last lg:order-none">
            <div class="min-w-max flex justify-end items-center gap-4">
                <div class="w-[280px] sm:w-[270px] lg:w-[300px] flex justify-start items-center">
                    <a routerLink="metal"
                        routerLinkActive="bg-c19725 text-white font-medium outline-c19725 hover:bg-c19725 hover:text-white"
                        [routerLinkActiveOptions]="{ exact: true }"
                        class="flex-1 px-4 py-2 rounded-tl-[5px] rounded-bl-[5px] border-[0.50px] border-[#D9D9D9] flex justify-center items-center text-[#898989] text-sm sm:text-sm lg:text-base hover:bg-[#f6f1cb] hover:text-black">
                        Metal Part
                    </a>

                    <a routerLink="stone"
                        routerLinkActive="bg-c19725 text-white font-medium outline-c19725 hover:bg-c19725 hover:text-white"
                        class="flex-1 px-4 py-2 rounded-tr-[5px] rounded-br-[5px] border-[0.50px] border-[#D9D9D9] flex justify-center items-center text-[#898989] text-sm sm:text-sm lg:text-base hover:bg-[#f6f1cb] hover:text-black">
                        Stone
                    </a>
                </div>
            </div>
        </div>
    </div>
    <router-outlet />
</div>